<template>
  <div class="talent-eval-card" :class="{active:active,disabled:disabled}" :style="cardStyle">
    <div class="standard-size-12 color-gray-7 justify-between flex top" v-if="$slots.top">
      <slot name="top"></slot>
    </div>
    <div class="standard-size-16 ellipsis title font-bolder color-gray-10" v-if="$slots.title">
      <slot name="title"></slot>
    </div>
    <div class="standard-size-12 level" v-if="$slots.level">
      <slot name="level"></slot>
    </div>
    <i class="yxt-icon-check font-size-12" v-if="active"/>
  </div>
</template>

<script>
export default {
  name: 'YxtbizEvalCard',
  props: {
    active: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '444px'
    },
    height: {
      type: String,
      default: ''
    }
  },
  computed: {
    cardStyle() {
      return {
        width: this.width,
        height: this.height,
        background: this.disabled ? '#f5f5f5' : `url(${this.$staticBaseUrl}'ufd/c4d5f9/gwnl/pc/img/eval-card.png)' no-repeat top right`,
        boxSizing: 'border-box'
      };
    }
  }
};
</script>
<style lang="scss">
.talent-eval-card {
  background: url(https://stc.yxt.com/ufd/b0174a/evaluation/pc/img/reportBackground.png) no-repeat 100% 0,linear-gradient(213deg,#fafbff,#fff 100%,#fff 0);
  background-size: 444px 1px;
  border: 1px solid #E9E9E9;
  border-radius: 4px;
  padding: 20px;
  position: relative;
  cursor: pointer;

  &:hover{
    border-color: var(--color-primary-6);
  }

  &.disabled {
    cursor: default;

    &:hover {
      border-color: #e9e9e9;
    }
  }

  &.active {
    border-color: var(--color-primary-6);

    &::before {
      content: '';
      position: absolute;
      width: 0;
      height: 0;
      border-bottom: 34px solid var(--color-primary);
      border-left: 34px solid transparent;
      bottom: 0;
      right: 0;
    }
    .yxt-icon-check {
      position: absolute;
      right: 4px;
      bottom: 4px;
      color: #fff;
    }
  }

  .top {
    &+.title {
      margin-top: 16px;
    }
  }

  .title {
    &+.level {
      margin-top: 16px;
    }
  }
}
</style>